var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTagIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.18694 8.46007C2.55501 9.16586 2.54142 10.2306 3.12138 10.9797C4.27225 12.4661 5.5319 13.7258 7.01831 14.8766C7.76735 15.4566 8.83214 15.443 9.53793 14.8111C11.4541 13.0954 13.2088 11.3024 14.9024 9.33191C15.0698 9.13713 15.1745 8.89839 15.198 8.64257C15.302 7.51143 15.5155 4.25255 14.6305 3.36753C13.7454 2.4825 10.4866 2.69603 9.35543 2.79996C9.09961 2.82347 8.86087 2.9282 8.66603 3.09562C6.69564 4.78913 4.90264 6.54392 3.18694 8.46007Z",
    stroke: "#979797",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7457 5.39997C12.2676 5.39997 12.6906 5.82302 12.6906 6.34488C12.6906 6.86674 12.2676 7.28979 11.7457 7.28979C11.2238 7.28979 10.8008 6.86674 10.8008 6.34488C10.8008 5.82302 11.2238 5.39997 11.7457 5.39997Z",
    stroke: "#979797",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.85156 10.2585L7.74137 12.1484L5.85156 10.2585Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagIcon);
export default __webpack_public_path__ + "static/media/tag-icon.cb1f97b5005bdc5d5b348acec2c018b4.svg";
export { ForwardRef as ReactComponent };